// Default Libraries
import { createActions } from '../helpers/redux';

export const PageActions = createActions({
  toggleState(key, elementId, reducerType, currentState) {
    return {
      key,
      elementId,
      reducerType,
      currentState,
    };
  },

  setReportHistoryViewState(key, elementId, reducerType, currentState) {
    return {
      key,
      elementId,
      reducerType,
      currentState,
    };
  },
});



// WEBPACK FOOTER //
// ./src/actions/page.js